import { motion } from 'framer-motion';

export default function SplashScreen() {
    return (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-neutral-950">
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className="flex flex-col items-center gap-4"
            >
                <motion.div
                    animate={{
                        boxShadow: [
                            '0 0 0 0px rgba(16, 185, 129, 0)',
                            '0 0 0 20px rgba(16, 185, 129, 0)',
                        ],
                    }}
                    transition={{
                        duration: 1.5,
                        repeat: Infinity,
                        ease: 'easeInOut',
                    }}
                    className="flex h-24 w-24 items-center justify-center rounded-2xl border border-emerald-500/20 bg-neutral-900 shadow-2xl"
                >
                    <img
                        src="/sisumail_logo.webp"
                        alt="Sisumail Logo"
                        className="h-16 w-16 object-contain"
                    />
                </motion.div>

                <motion.h1
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="font-bold text-2xl text-white tracking-wider"
                >
                    SISUMAIL
                </motion.h1>
            </motion.div>
        </div>
    );
}
